import { Button, Checkbox } from "antd/es";
import store from "../../store";

export const ModelFilters = (props) => {
    const { filters, setFilters, clearSelection } = props;

    const numSelected = store.models.use(s => s.selection.length);

    return (
        <div className="model-storage-filters">
            <Checkbox checked={filters.localOnly} onChange={e => setFilters(f => ({ ...f, localOnly: e.target.checked }))}>
                Only show local models
            </Checkbox>

            {numSelected ?
                <Button size="small" onClick={clearSelection}>Clear selection ({numSelected})</Button>
                :
                <Button size="small" disabled>Clear selection</Button>}
        </div>
    );
};
